var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.805 0.195897C15.545 -0.0651363 15.123 -0.0651363 14.862 0.195897L8.00006 7.05783L1.13803 0.195897C0.878008 -0.0651363 0.456058 -0.0651363 0.194975 0.195897C-0.0649917 0.455864 -0.0649917 0.877864 0.194975 1.13788L7.05803 7.99986L0.194975 14.8619C-0.0649917 15.1229 -0.0649917 15.5449 0.194975 15.8049C0.456058 16.0649 0.878008 16.0649 1.13803 15.8049L8.00006 8.94286L14.862 15.8049C15.123 16.0649 15.545 16.0649 15.805 15.8049C16.065 15.5449 16.065 15.1229 15.805 14.8619L8.94306 7.99986L15.805 1.13788C16.065 0.877864 16.065 0.455864 15.805 0.195897Z",
    fill: "#a2a1af"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.39bf3d159c2370497d05c53192387fa8.svg";
export { ForwardRef as ReactComponent };